interface IAddress {
  address: string;
  postCode: string;
  province: string;
  district: string;
  subdistrict: string;
  building?: string;
  road?: string;
  moo?: string;
}
export const getFullAddress = (data: IAddress) => {
  if (!data) return "";
  const {
    address,
    postCode,
    province,
    district,
    subdistrict,
    building,
    road,
    moo,
  } = data;

  const isBangkok = province === "กรุงเทพมหานคร" || province === "กทม";
  const mapAddress = [
    { key: "addressNo", label: "", value: address },
    { key: "building", label: "อาคาร ", value: building },
    { key: "road", label: "ถ.", value: road },
    { key: "moo", label: "หมู่ ", value: moo?.toString() },
    {
      key: "subdistrict",
      label: isBangkok ? "แขวง" : "ต.",
      value: subdistrict,
    },
    {
      key: "district",
      label: isBangkok ? "เขต" : "อ.",
      value: district,
    },
    { key: "province", label: "จ.", value: province },
    { key: "postCode", label: "", value: postCode },
  ];

  return mapAddress
    .reduce((acc, cur) => {
      if (!cur.value) return acc;
      const current = `${cur.label}${cur.value}`.trim();
      return `${acc} ${current}`;
    }, "")
    .trim();
};
